// When does the refund record for an opportunity need re-reading?
//
// Both places that show it (OpportunityOverviewDetail, Payment) used to re-fetch
// `/unit_reservation_refunds/opportunity/:id/` whenever the props OBJECT changed identity. Overview
// rebuilds `data` as a fresh object on every one of its own state resets (loading flips, tab
// changes, a paymentData/documentData reload), so one tab on the SkyVN UAT tenant issued the same
// GET twenty-four times and got twenty-four 404s (CPI-1388).
//
// The rule: re-read when the fields that travel with a refund change (id, sr_status, status, the
// update stamp when the payload carries one), not when the reference does. This is NOT the only
// trigger, and it must not be: approve / decline write the refund FIRST and only then call
// onUpdateOpportunity (RefundRequestDetail.jsx), so a refund can change while the opportunity's
// fields do not. Those paths refresh explicitly -- RefundRequestDetail's onSuccess re-reads, and a
// replaced refundData list from Opportunities.jsx still re-reads in OpportunityOverviewDetail.

const stamp = o => (o && (o.updated_at || o.updatedAt)) || null;

/** Opportunity fields whose change can mean a different refund record. */
export const refundKeyOfOpportunity = d => (
  d ? [d.id, d.sr_status, d.status, stamp(d)].join('|') : ''
);

/** Payment (unit reservation token) fields whose change can mean a different refund record. */
export const refundKeyOfPayment = p => (
  p ? [p.opportunityID, p.id, p.status, stamp(p)].join('|') : ''
);

export const shouldRefetchRefund = (prev, next, keyOf) => keyOf(prev) !== keyOf(next);

// Book API only creates a refund record when it moves the opportunity to pending_refund, and the
// record's later states map to refunded / refund_declined. For every other sr_status the GET is a
// guaranteed 404, so the record is not read at all (the console "spam" on ordinary bookings).
const REFUND_SR_STATUSES = ['pending_refund', 'refunded', 'refund_declined'];

/** Whether this opportunity's sr_status is one that can carry a unit reservation refund record. */
export const opportunityCanHaveRefund = o => !!(o && REFUND_SR_STATUSES.includes(o.sr_status));



// WEBPACK FOOTER //
// ./src/components/Opportunities/refundRefetch.js